export default __webpack_public_path__ + "static/media/withdraw.e01f32a7.svg";